import { t } from 'i18next';
import { ObjectSchema } from 'yup';
import { getEnumValues, getEnumValuesNullable } from '../../../services/common/miscUtils';
import Yup, { maxMobileNumberLength, minMobileNumberLength, regExEmail } from '../../../services/common/validation';
import {
  CorrespondenceMethodEnum,
  CountryCodeEnum,
  GenderEnum,
  MaritalStatusEnum,
  NoYesEnum,
  TitleEnum,
} from '../../../types/forms';
import { NationalityEnum } from '../../../types/nationality';
import { CustomerDetailsFormModel_PL } from './formModel';

export const getValidationSchema = (): ObjectSchema<CustomerDetailsFormModel_PL> => {
  return Yup.object({
    title: Yup.string().requiredWithMsg().oneOf(getEnumValues(TitleEnum)),
    gender: Yup.string().requiredWithMsg().oneOf(getEnumValues(GenderEnum)),
    maritalStatus: Yup.string().requiredWithMsg().oneOf(getEnumValues(MaritalStatusEnum)),
    firstName: Yup.string().requiredWithMsg().unaccentedLetters().lengthBetween(0, 64),
    lastName: Yup.string().requiredWithMsg().unaccentedLetters().lengthBetween(0, 64),
    middleName: Yup.string().unaccentedLetters().lengthBetween(0, 64),
    maidenName: Yup.string()
      .unaccentedLetters()
      .when(['gender', 'maritalStatus'], {
        is: (gender: GenderEnum, maritalStatus: MaritalStatusEnum) => {
          const isFemale = gender === GenderEnum.female;
          const isOrWasMarried = [
            MaritalStatusEnum.married,
            MaritalStatusEnum.divorced,
            MaritalStatusEnum.separated,
          ].includes(maritalStatus);
          return isFemale && isOrWasMarried;
        },
        then: (schema) => schema.requiredWithMsg(),
        otherwise: (schema) => schema,
      })
      .lengthBetween(0, 64),
    dateOfBirth: Yup.string().requiredWithMsg(),
    email: Yup.string().requiredWithMsg().matches(regExEmail, t('validation:invalidEmail')),
    countryCode: Yup.string().requiredWithMsg().oneOf(getEnumValues(CountryCodeEnum)),
    phoneNumber: Yup.string().requiredWithMsg().lengthBetween(minMobileNumberLength, maxMobileNumberLength),
    makeIndemnifier: Yup.string().notRequired().oneOf(getEnumValuesNullable(NoYesEnum)),
    correspondenceMethod: Yup.string().requiredWithMsg().oneOf(getEnumValues(CorrespondenceMethodEnum)),
    nationality: Yup.string().requiredWithMsg().oneOf(getEnumValues(NationalityEnum)),
  });
};
